import { useCallback, useState } from 'react'

function storageKey(gameId) {
  return `Memory-tutorial-done:${gameId}`
}

export function hasCompletedTutorial(gameId) {
  try {
    return localStorage.getItem(storageKey(gameId)) === '1'
  } catch {
    return false
  }
}

export function markTutorialComplete(gameId) {
  try {
    localStorage.setItem(storageKey(gameId), '1')
  } catch {
    /* ignore */
  }
}

export function clearTutorialComplete(gameId) {
  try {
    localStorage.removeItem(storageKey(gameId))
  } catch {
    /* ignore */
  }
}

/**
 * Interactive tutorial state for a game.
 * `step` is a string id the game advances when the user does the taught action.
 */
export function useTutorial(gameId) {
  const [active, setActive] = useState(false)
  const [step, setStep] = useState(null)

  const needsTutorial = !hasCompletedTutorial(gameId)

  const start = useCallback(
    (firstStep) => {
      setActive(true)
      setStep(firstStep)
    },
    [],
  )

  const go = useCallback((nextStep) => {
    setStep(nextStep)
  }, [])

  const skip = useCallback(() => {
    markTutorialComplete(gameId)
    setActive(false)
    setStep(null)
  }, [gameId])

  const finish = useCallback(() => {
    markTutorialComplete(gameId)
    setActive(false)
    setStep(null)
  }, [gameId])

  const restart = useCallback(
    (firstStep) => {
      clearTutorialComplete(gameId)
      start(firstStep)
    },
    [gameId, start],
  )

  return {
    active,
    step,
    needsTutorial,
    start,
    go,
    skip,
    finish,
    restart,
  }
}
